export const AppcuesIdentify = (id, trackProps) => window.Appcues.identify(id, trackProps)

export const AppcuesPage = () => window.Appcues.page()
